import { Box, Divider, Typography } from '@mui/material';
import { askAardvarkCopy, askAardvarkHelpHint } from '../utils/userFacingCopy';

interface AskAardvarkHelpHintProps {
  /** What someone might ask Claude about on this page. */
  about: string;
}

/** Short help-sidebar nudge pointing at the top-bar Ask Aardvark starters. */
export default function AskAardvarkHelpHint({ about }: AskAardvarkHelpHintProps) {
  return (
    <>
      <Divider sx={{ my: 2 }} />
      <Box>
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: 'primary.main' }}>
          {askAardvarkCopy.helpHeading}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {askAardvarkHelpHint(about)}
        </Typography>
      </Box>
    </>
  );
}
